module.exports = __webpack_public_path__ + "static/img/3634_phase_function_Paper_Points.ac66a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3634_phase_function_Paper_Points.png
// module id = j4W3
// module chunks = 0